<template>
  <div v-if="loading"></div>
  <div v-else>
      <v-dialog v-model="dialog" persistent max-width="600px" light>
          <v-card color="rgb(255, 0, 0, 0.2)">
              <v-toolbar class="custom-font-regular requerimiento-toolbar" color="#dedfe4">
                  <v-toolbar-title>Consulta</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items right>
                      <v-btn icon @click="hideAddMatch"><v-icon>close</v-icon></v-btn>
                  </v-toolbar-items>
              </v-toolbar>
              <v-card-text class="body-content">
                  <div>
                      Asignar partido a la consulta <b>{{ consulta.title }}</b>:
                  </div>
                  <v-spacer></v-spacer>
                  <div class="flex-column">
              <v-select class="ma-2 pa-2"
                      v-model="torneo"
                      :items="torneos"
                      item-text="description"
                      item-value="id"
                      :error-messages="torneoErrors"
                      label="Torneo" @change="fetchFechas"
                      no-data-text="No hay datos disponibles"></v-select>
              <v-select class="ma-2 pa-2"
                       v-model="fecha"
                      :items="fechas"
                      item-text="nombreCompleto"
                      item-value="id"
                      :error-messages="fechaErrors"
                      label="Fecha" @change="fetchPartidos"
                      no-data-text="No hay datos disponibles"></v-select>
              <v-select class="ma-2 pa-2"
                       v-model="partido"
                      :items="partidos"
                      item-text="description"
                      item-value="id"
                      :error-messages="partidoErrors"
                      label="Partido" required @change="$v.partido.$touch()"
                      no-data-text="No hay datos disponibles"></v-select>
            </div>
              </v-card-text>
              <v-card-actions class="buttons-content">
                  <v-btn color="error" flat @click="hideAddMatch">Cancelar</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat  @click="asignarPartidoConsulta()" :disabled="loading || !isValid">Asignar partido</v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],

  props: {
    consulta: Object
  },

  validations: {
    torneo: { required },
    fecha: { required },
    partido: { required }
  },

  data () {
    return {
      loading: false,
      dialog: true,
      editPath: 'consulta/asignar-partido',
      torneos: [],
      fechas: [],
      partidos: [],
      torneo: null,
      fecha: null,
      partido: null
    }
  },

  computed: {
    isValid () {
      return this.partido !== null
    },
    torneoErrors () {
      const errors = []
      if (!this.$v.torneo.$dirty) return errors
      !this.$v.torneo.required && errors.push('El torneo es requerido.')
      return errors
    },
    fechaErrors () {
      const errors = []
      if (!this.$v.fecha.$dirty) return errors
      !this.$v.fecha.required && errors.push('La fecha es requerida.')
      return errors
    },
    partidoErrors () {
      const errors = []
      if (!this.$v.partido.$dirty) return errors
      !this.$v.partido.required && errors.push('El partido es requerido.')
      return errors
    }
  },
  methods: {
    hideAddMatch () {
      this.$emit('hideAddPartidoDialog')
    },
    getPayload () {
      let payload = {}
      payload.partido = this.partido
      return payload
    },
    asignarPartidoConsulta () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        let payload = this.getPayload()
        this.axios
          .put(`${this.editPath}/${this.consulta.id}`, payload)
          .then((response) => {
            this.$router.go()
            this.loading = false
          })
          .catch(error => {
            this.$store.commit('setErrorMsg', error)
            this.loading = false
          })
      }
    },
    goToAddPartido () {
      this.addPartido = true
    },
    fetchTorneos () {
      this.axios
        .get('informe-auditoria/torneos?active=true')
        .then(response => {
          this.torneos = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchFechas () {
      this.axios
        .get(`informe-auditoria/fechas?torneo=${this.torneo}&order=desc`)
        .then(response => {
          this.fecha = null
          this.partido = null
          this.fechas = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchPartidos () {
      this.axios
        .get(`informe-auditoria/partidos?torneo=${this.torneo}&fecha=${this.fecha}&fromConsultas=true&club=${this.consulta.autor.club.pk}`)
        .then(response => {
          this.partido = null
          this.partidos = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    }
  },

  created () {
    this.loading = true
    this.fetchTorneos()
  }
}
</script>

<style scoped>
  .custom-font-regular {
      font-family: SourceSansProRegular, sans-serif;
  }

  .body-content {
      padding: 30px;
      background-color: #e9eaec;
  }

  .buttons-content {
      padding: 1em 0.5em 0.5em 0.5em;
      background-color: #e9eaec;
  }
</style>
